import { jsx as i, jsxs as c } from "@emotion/react/jsx-runtime";
import { Stack as l } from "../Stack/index.js";
import { StepContainer as S, Progress as g, FillingBackground as C, Filling as a } from "./Stepper.styled.js";
import { Step as E } from "./Step/Step.js";
import { StepState as e } from "./Step/Step.types.js";
const P = (t, r) => t < r ? e.COMPLETED : t === r ? e.ACTIVE : e.UPCOMING, h = (t, r, n) => t === e.COMPLETED || t === e.ACTIVE ? 100 : t === e.UPCOMING && r ? n : 0, d = ({
  steps: t,
  activeStep: r,
  activeStepProgress: n = 0
}) => /* @__PURE__ */ i(l, { gap: "0", direction: "row", justifyContent: "center", children: t.map((m, o) => {
  const u = o !== 0, s = P(o, r), p = o === r + 1, f = h(s, p, n);
  return /* @__PURE__ */ c(S, { children: [
    /* @__PURE__ */ i(E, { title: m, state: s }),
    u && /* @__PURE__ */ c(g, { children: [
      /* @__PURE__ */ i(C, {}),
      /* @__PURE__ */ i(a, { width: f, active: p })
    ] })
  ] }, o);
}) });
export {
  d as Stepper
};
